const convertNumberToPrice = (number: number) => {
  const formattedNum = Math.floor(number as number).toLocaleString();
  return formattedNum !== "NaN" ? formattedNum : "0";
};

export default convertNumberToPrice;
